var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.21966C0 0.992359 0.994923 -0.00256348 2.22222 -0.00256348H17.7778C19.0051 -0.00256348 20 0.992359 20 2.21966V17.7752C20 19.0025 19.0051 19.9974 17.7778 19.9974H2.22222C0.994923 19.9974 0 19.0025 0 17.7752V2.21966ZM9.9987 11.9424C9.53846 11.9424 9.16536 11.5693 9.16536 11.109L9.16537 4.44238C9.16537 3.98215 9.53846 3.60905 9.9987 3.60905C10.4589 3.60905 10.832 3.98215 10.832 4.44238L10.832 11.109C10.832 11.5693 10.4589 11.9424 9.9987 11.9424ZM10.0002 13.3311C9.38657 13.3311 8.88911 13.8286 8.88911 14.4422C8.88911 15.0559 9.38657 15.5533 10.0002 15.5533C10.6139 15.5533 11.1113 15.0559 11.1113 14.4422C11.1113 13.8286 10.6139 13.3311 10.0002 13.3311Z",
    fill: "#FF3A2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.09cebc645f7aad8a47977eb97d2a713c.svg";
export { ForwardRef as ReactComponent };